import { render, staticRenderFns } from "./flowRequirementList.vue?vue&type=template&id=940a7c1c&"
import script from "./flowRequirementList.vue?vue&type=script&lang=js&"
export * from "./flowRequirementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports